module.exports = __webpack_public_path__ + "img/1_036.4838b8ec.jpg";